import {
  IShortcutList,
  IShortcutListRequest,
  IShortcutPriceGroup,
  TShortcutPriceList,
} from 'core/model/interfaces/shortcuts';
import {
  ICreateShortcutRequest,
  IUpdateShortcutRequest,
} from 'core/model/interfaces/shortcuts/shortcuts-form.interface';
import type {
  ICreateShortcutRequestDTO,
  IShortcutListRequestDTO,
  IShortcutListResponseDTO,
  IShortcutPriceGroupDTO,
  IUpdateShortcutRequestDTO,
  TShortcutPriceListDTO,
} from './shortcuts.dto';

export const mapPriceList = (priceList: TShortcutPriceListDTO): TShortcutPriceList => ({
  label: priceList.name,
  value: priceList.id.toString(),
});

export const mapPriceGroup = (priceGroup: IShortcutPriceGroupDTO): IShortcutPriceGroup => ({
  label: priceGroup.name,
  value: priceGroup.externalId,
  options: priceGroup.priceLists.map(mapPriceList),
});

export const mapShortcutListRequest = (params: IShortcutListRequest): IShortcutListRequestDTO => ({
  ...(params.query && { name: params.query }),
  page: params.page,
  itemsPerPage: params.itemsPerPage,
  ...(params.priceListIds?.length && { priceListIds: params.priceListIds.join(',') }),
});

export const mapShortcutListResponse = (response: IShortcutListResponseDTO): IShortcutList => ({
  pagination: response.pagination,
  shortcuts: response.shortcuts.map(shortcut => ({
    id: shortcut.id,
    name: shortcut.name,
    images: shortcut.items,
    isActive: shortcut.isActive,
    priceGroups: shortcut.priceGroups.map(mapPriceGroup),
  })),
});

export const mapShortcutCreationRequest = (body: ICreateShortcutRequest): ICreateShortcutRequestDTO => ({
  name: body.name,
  isActive: body.isActive,
  priceListIds: body.priceListIds.map(priceListId => Number(priceListId)),
  items: body.images,
});

export const mapShortcutUpdateRequest = (body: IUpdateShortcutRequest): IUpdateShortcutRequestDTO => ({
  id: body.id,
  ...(body.name !== undefined && { name: body.name }),
  ...(body.isActive !== undefined && { isActive: body.isActive }),
  ...(body.priceListIds !== undefined && {
    priceListIds: body.priceListIds.map(priceListId => Number(priceListId)),
  }),
  ...(body.images !== undefined && { items: body.images }),
});
